import axios from 'axios';

import { BrregEnhetResponse } from './types';

import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/brreg';

async function getByOrgNr(orgNr: string): Promise<BrregEnhetResponse[]> {
  const response = await axios.get(`${baseUrl}/search?orgNr=${orgNr}`);
  return response.data;
}

async function getByName(name: string): Promise<BrregEnhetResponse[]> {
  const response = await axios.get(`${baseUrl}/search?name=${name}`);
  return response.data;
}

async function getDagligLeder(orgNr: string) {
  const response = await axios.get(`${baseUrl}/dagligleder?orgNr=${orgNr}`);
  return response.data;
}

async function getUnderEnhetCount(orgNr: string): Promise<number> {
  const trimmed = orgNr.trim();
  if (!trimmed) {
    return 0;
  }

  const response = await axios.get<number>(
    `${baseUrl}/${encodeURIComponent(trimmed)}/underenheter/count`,
  );
  return response.data;
}

async function getOppstartsdato(orgNr: string): Promise<Date> {
  const trimmed = orgNr.trim();
  if (!trimmed) {
    return null;
  }

  const response = await axios.get<Date>(`${baseUrl}/${encodeURIComponent(trimmed)}/oppstartsdato`);
  return response.data;
}

export default {
  getByOrgNr,
  getByName,
  getDagligLeder,
  getUnderEnhetCount,
  getOppstartsdato,
};
